import PropTypes from 'prop-types'
import algoliaSearch from 'algoliasearch/lite'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

import getInitialState from 'Common/utils/getInitialState'
import { materials } from 'Packages/search'

import getTags from './getTags'

const searchClient = algoliaSearch(
  process.env.ALGOLIA_APPLICATION_ID,
  process.env.ALGOLIA_SEARCH_ONLY_KEY
)

export default function SearchConfig({ children }) {
  const { pathname } = useLocation()
  const { tag: collectionTag, slugMap, cambridgeAccess } = getInitialState()

  const [searchState, setSearchState] = useState({})

  // Initialize currentTags with the pathname rendered on application load
  const [currentTags, setCurrentTags] = useState(() =>
    getTags({ collectionTag, pathname, slugMap })
  )

  const handleSearchStateChange = newState => {
    // Reset to first page when changing filters
    // 'Filters' in this case are the tag_list filters, which change when navigating between (sub)collections.
    // NB: Algolia's API docs state that `page` is a 0-based number, but setting the `page` value
    // from `onSearchStateChange` appears to require a 1-based number.
    if (
      searchState.configure &&
      searchState.configure.filters !== newState.configure.filters
    ) {
      return setSearchState({
        ...newState,
        page: 1,
      })
    }

    return setSearchState(newState)
  }

  const getFilters = () => {
    const tagFilters = currentTags.map(t => `tag_list:'${t}'`).join(' AND ')

    if (cambridgeAccess) {
      return tagFilters
    }

    return `${tagFilters} AND content_availability:standard`
  }

  useEffect(() => {
    // Update currentTags whenever the pathname changes
    setCurrentTags(getTags({ collectionTag, pathname, slugMap }))
  }, [pathname])

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={materials}
      searchState={searchState}
      onSearchStateChange={handleSearchStateChange}
    >
      <Configure filters={getFilters()} />
      {children}
    </InstantSearch>
  )
}

SearchConfig.propTypes = {
  children: PropTypes.node.isRequired,
}
